import { Component, input, InputSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ItFooterComponent,
  ItIconComponent,
  ItListComponent,
  ItListItemComponent,
} from 'design-angular-kit';
import { environment } from '../../../environments/environment';
import { Contacts, FooterExtraLink, FooterSection } from '../../shared/interfaces/footer.interface';
import { SocialsComponent } from '../socials/socials.component';

@Component({
  selector: 'drw-footer',
  imports: [
    ItFooterComponent,
    ItIconComponent,
    ItListComponent,
    ItListItemComponent,
    TranslatePipe,
    SocialsComponent,
  ],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  protected small: InputSignal<boolean> = input<boolean>(false);
  protected shadow: InputSignal<boolean> = input<boolean>(false);
  protected dark: InputSignal<boolean> = input<boolean>(false);

  protected institutionName: InputSignal<string> = input<string>('Istituzione');
  protected tagLine: InputSignal<string | undefined> = input<string | undefined>(undefined);
  protected sections: InputSignal<FooterSection[]> = input<FooterSection[]>([
    {
      title: 'Amministrazione',
      links: [
        { text: 'Giunta e consiglio', url: '#' },
        { text: 'Aree di competenza', url: '#' },
        { text: 'Dipendenti', url: '#' },
        { text: 'Luoghi', url: '#' },
        { text: 'Associazioni e società partecipate', url: '#' },
      ],
    },
    {
      title: 'Servizi',
      links: [
        { text: 'Pagamenti', url: '#' },
        { text: 'Sostegno', url: '#' },
        { text: 'Domande e iscrizioni', url: '#' },
        { text: 'Segnalazioni', url: '#' },
        { text: 'Autorizzazioni e concessioni', url: '#' },
        { text: 'Certificati e dichiarazioni', url: '#' },
      ],
    },
    {
      title: 'Novità',
      links: [
        { text: 'Notizie', url: '#' },
        { text: 'Eventi', url: '#' },
        { text: 'Comunicati stampa', url: '#' },
      ],
    },
    {
      title: 'Documenti',
      links: [
        { text: 'Progetti e attività', url: '#' },
        { text: 'Delibere, determine e ordinanze', url: '#' },
        { text: 'Bandi', url: '#' },
        { text: 'Concorsi', url: '#' },
        { text: 'Albo pretorio', url: '#' },
      ],
    },
  ]);

  protected contacts: Contacts = {
    name: environment.contacts.name,
    address: environment.contacts.address,
    phone: environment.contacts.phone,
    pec: environment.contacts.pec,
    email: environment.contacts.email,
    fiscalCode: environment.contacts.fiscalCode,
  };

  protected extraLinks: InputSignal<FooterExtraLink[]> = input<FooterExtraLink[]>([
    { label: 'Media policy', url: '#' },
    { label: 'Note legali', url: '#' },
    { label: 'Privacy policy', url: '#' },
    { label: 'Mappa del sito', url: '#' },
    {
      label: 'Dichiarazione di accessibilità',
      url: '#',
      screenLabel: '(link esterno su sito AgID)',
    },
  ]);
}
